<head>
    <link href="https://api.mapbox.com/mapbox-gl-js/v2.5.1/mapbox-gl.css" rel="stylesheet">    
    <script src="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.2/mapbox-gl-draw.js"></script>
    <link rel="stylesheet" href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.2/mapbox-gl-draw.css" type="text/css">
    <link rel="stylesheet" href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css" type="text/css">
</head>
<map [mapName]="MAP_BUILD_NAMES.Unilever"></map>

<!-- notificaciones de sistema y texto para tooltip -->
<system-notification class="system-notification"></system-notification>
<app-tooltip *ngIf="this.toolCarSelectorService.isCarSelectionToolTipVisible" class="tooltip-container" [Mensaje]="intersectMsg" [isVisible]="this.toolCarSelectorService.isCarSelectionToolTipVisible" (visibilityChange)="onToolTipVisibilityChange($event)"></app-tooltip>

<locations-section></locations-section>
<route-section ></route-section>
<potential-zones-section></potential-zones-section>
<prospects-section></prospects-section>
<frecuency-zones-section></frecuency-zones-section>
<app-territories-section></app-territories-section>
<!-- <locations-section></locations-section> -->
<ng-template #dynamicComponentContainer></ng-template>
<screen-blocker></screen-blocker>

<!-- handle de arrastre para herramientas -->
<!-- <map-tools-zones></map-tools-zones> -->
 <map-tools></map-tools>

<basemap-selector class="map-selector-position"></basemap-selector>

<!-- <ei-chat-bot></ei-chat-bot> -->